module.exports = __webpack_public_path__ + "static/media/filter-arrow.44eb159a.svg";